export default class extends Controller {
  static targets = ["detailsContainer"];

  connect() {
    App.Helpers.listenToCustomEvent(document, "control:expand", this.expand.bind(this));
    App.Helpers.listenToCustomEvent(document, "control:collapse", this.close.bind(this));
  }

  expand(event) {
    const { containerID } = event.detail;
    if (containerID == this.transactionID) {
      this.open = true;
      if (!this.detailsContainerTarget.innerHTML) {
        this.detailsContainerTarget.innerHTML = App.spinner();
        App.Helpers.ajaxRequest({url: this.detailsURL, successHandler: this.setDetailsContent.bind(this)});
      }
    }
  }

  close(event) {
    const { containerID } = event.detail;
    if (containerID == this.transactionID) {
      this.open = false;
    }
  }

  setDetailsContent(html) {
    this.detailsContainerTarget.innerHTML = html;
  }

  //
  // GETTERS AND SETTERS
  //

  get transactionID() {
    return this.data.get("transaction-id");
  }

  set open(value) {
    this.detailsContainerTarget.classList[value ? "add" : "remove"]("expanded");
  }

  get detailsURL() {
    return this.data.get("details-url");
  }
};



// WEBPACK FOOTER //
// ./app/components/financials/transactions/assets/javascript/financials-transactions-transaction-card-table-row-controller.js